export const MARKETS = [
  {
    region: "Asia",
    desc: "Active sourcing and distribution corridors across South, Southeast, and East Asia — servicing manufacturers, refiners, and government buyers.",
    partners: "India · Singapore · Vietnam · South Korea · Indonesia",
  },
  {
    region: "MENA",
    desc: "Strategic presence across the Middle East and North Africa with strong routes through the UAE — a key global trading hub for petrochemicals and metals.",
    partners: "UAE · Saudi Arabia · Oman · Egypt · Morocco",
  },
  {
    region: "LATAM",
    desc: "Direct engagement with producers and distributors across Latin America for food commodities, minerals, and metals.",
    partners: "Brazil · Ecuador · Peru · Chile · Colombia",
  },
  {
    region: "North America",
    desc: "Commercial engagement with U.S. buyers and distributors across industrial and consumer supply chains.",
    partners: "United States",
  },
];

export const MARKET_STATS = [
  { value: "4",  label: "Continents covered" },
  { value: "15+", label: "Country corridors" },
  { value: "4",  label: "Commodity verticals" },
  { value: "B2B + B2G", label: "Client types" },
];
